// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__PnCD9","box":"style_box__7JTU1","active":"style_active__zZ8fd","title":"style_title__KsH7W","item":"style_item__PZcxi"};